var _polygon, _polygon2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg97127264170014(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.381,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 70.806,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.141,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 34.29,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.652,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 62.348,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.333,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 36.814,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 142.041,
    y: 69.54,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 504.5289 282.2664)",
    style: {
      fill: "#E6E6E6"
    },
    width: 220.447,
    height: 143.186
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.512,
    y: 69.54,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 497.2177 282.2664)",
    style: {
      fill: "#F0F0F0"
    },
    width: 222.193,
    height: 143.186
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.789,
    y: 34.627,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 389.7421 -107.4756)",
    style: {
      fill: "#FAFAFA"
    },
    width: 127.64,
    height: 213.013
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "328.971,204.953 302.031,77.313 266.716,77.313 293.656,204.953  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "287.941,204.953 261.001,77.313 245.052,77.313 271.992,204.953  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "224.656,204.953 197.717,77.313 170.477,77.313 197.417,204.953  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.574,
    y: 140.842,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 283.527 -1.2605)",
    style: {
      fill: "#E6E6E6"
    },
    width: 127.64,
    height: 0.583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.988,
    y: 69.54,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 497.2177 282.2664)",
    style: {
      fill: "#F0F0F0"
    },
    width: 13.243,
    height: 143.186
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.701,
    y: 140.842,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 396.6548 -114.3883)",
    style: {
      fill: "#E6E6E6"
    },
    width: 127.64,
    height: 0.583
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.378,
    y: 69.54,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 497.2176 282.2664)",
    style: {
      fill: "#E6E6E6"
    },
    width: 0.461,
    height: 143.186
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 405.928,
    y: 270.96,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 852.0256 646.7177)",
    style: {
      fill: "#F0F0F0"
    },
    width: 40.169,
    height: 104.799
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.286,
    y: 375.758,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 678.6707 758.1567)",
    style: {
      fill: "#F0F0F0"
    },
    width: 198.099,
    height: 6.64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.573,
    y: 270.96,
    style: {
      fill: "#F5F5F5"
    },
    width: 173.355,
    height: 104.799
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.366,
    y: 283.859,
    style: {
      fill: "#F0F0F0"
    },
    width: 141.769,
    height: 34.37
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.366,
    y: 328.488,
    style: {
      fill: "#F0F0F0"
    },
    width: 141.769,
    height: 34.37
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M301.337,303.4h35.827c1.056,0,1.919-0.864,1.919-1.919v-0.875c0-1.056-0.864-1.919-1.919-1.919 h-35.827c-1.056,0-1.919,0.864-1.919,1.919v0.875C299.418,302.537,300.281,303.4,301.337,303.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M301.337,348.03h35.827c1.056,0,1.919-0.864,1.919-1.919v-0.875c0-1.056-0.864-1.919-1.919-1.919 h-35.827c-1.056,0-1.919,0.864-1.919,1.919v0.875C299.418,347.166,300.281,348.03,301.337,348.03z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M310.374,253.313c0,0-0.483,17.645-18.994,17.645c-18.511,0-18.994-17.645-18.994-17.645H310.374z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M353.676,253.313c0,0-0.483,17.645-18.994,17.645c-18.511,0-18.994-17.645-18.994-17.645H353.676z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M310.374,241.622c0,0-0.483,17.645-18.994,17.645c-18.511,0-18.994-17.645-18.994-17.645H310.374z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M353.676,241.622c0,0-0.483,17.645-18.994,17.645c-18.511,0-18.994-17.645-18.994-17.645H353.676z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M396.978,253.313c0,0-0.483,17.645-18.994,17.645c-18.511,0-18.994-17.645-18.994-17.645H396.978z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M396.978,241.622c0,0-0.483,17.645-18.994,17.645c-18.511,0-18.994-17.645-18.994-17.645H396.978z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 385.324,
    y: 127,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 795.8716 301.5477)",
    style: {
      fill: "#E6E6E6"
    },
    width: 25.224,
    height: 47.548
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.678,
    y: 127,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 788.98 301.5477)",
    style: {
      fill: "#F5F5F5"
    },
    width: 29.624,
    height: 47.548
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.94,
    y: 140.473,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 545.2639 -243.7162)",
    style: {
      fill: "#FFFFFF"
    },
    width: 39.1,
    height: 20.602
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 423.517,
    y: 157.725,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 872.2567 362.9975)",
    style: {
      fill: "#E6E6E6"
    },
    width: 25.224,
    height: 47.548
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.87,
    y: 157.725,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 865.365 362.9975)",
    style: {
      fill: "#F5F5F5"
    },
    width: 29.624,
    height: 47.548
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.133,
    y: 171.197,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 614.1813 -251.1838)",
    style: {
      fill: "#FFFFFF"
    },
    width: 39.1,
    height: 20.603
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 72.749,
    y: 103.249,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 181.5733 274.5)",
    style: {
      fill: "#E6E6E6"
    },
    width: 36.075,
    height: 68.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.674,
    y: 103.249,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 171.717 274.5)",
    style: {
      fill: "#F5F5F5"
    },
    width: 42.369,
    height: 68.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.898,
    y: 122.517,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 223.1086 51.3914)",
    style: {
      fill: "#FFFFFF"
    },
    width: 55.921,
    height: 29.465
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M58.696,290.626c-4.769-14-19.312-19.212-23.533-28.052c-5.531-11.581-3.511-28.954,3.037-35.224 c5.69-5.448,18.276,31.39,19.697,35.505c4.889,14.155,5.582,24.661,5.64,34.838c0.848-8.651,1.621-16.594,2.211-22.723 c1.924-19.99,2.213-26.419,2.235-28.397c-0.591-0.966-1.29-2.092-1.702-2.697c-3.48-5.106-11.8-11.184-15.458-18.606 c-5.341-10.837-2.8-23.807,2.364-28.637c5.399-5.05,12.565,6.885,15.744,18.711c3.179,11.826-0.047,23.144,0.103,32.966 c0.046,1.926-0.515,9.243-1.417,19.391c2.618-10.919,6.188-18.235,12.035-25.052c7.192-8.384,13.739-18.595,18.727-17.275 c4.987,1.32,0.682,14.829-4.465,24.314c-4.583,8.446-23.401,16.871-26.807,23.662c-1.259,13.756-2.969,31.183-4.623,47.41 c2.364-8.381,1.476-9.085,8.708-21.916c4.3-7.629,19.433-17.036,20.512-11.795c1.059,5.144-2.599,15.148-8.698,22.086 c-4.92,5.597-14.421,5.591-17.015,9.063c-0.605,0.811-2.656,3.917-3.828,5.702c-2.029,19.809-3.92,37.296-4.714,43.258 l-0.929,0.061c0.22-1.54,1.257-11.617,2.597-24.952c-1.498-7.096-16.557-11.238-20.514-18.617 c-4.14-7.723-6.721-16.734-3.879-22.769c2.369-5.031,15.743,1.811,20.536,10.148c3.192,5.552,4.853,11.479,5.037,19.441 c0.905-9.084,1.869-18.844,2.774-28.056C62.174,300.117,60.125,294.821,58.696,290.626z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M72.841,382.399H42.956c-1.633,0-3.04-1.907-3.364-4.561l-2.121-17.343h40.857l-2.121,17.343 C75.88,380.491,74.474,382.399,72.841,382.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M79.182,361.792H36.616c-1.02,0-1.877-0.562-1.991-1.306l-0.87-5.674 c-0.134-0.872,0.796-1.635,1.991-1.635h44.307c1.196,0,2.125,0.763,1.991,1.635l-0.87,5.674 C81.059,361.23,80.202,361.792,79.182,361.792z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M210.578,374.09c25.991,14.555,62.376,26.908,86.778-0.889 c12.221-13.921,18.111-33.358,31.55-46.557c14.316-14.06,28.631-20.721,39.488-40.646c42.186-77.424-2.704-160.271-59.25-183.071 C262.377,84.07,159.27,78.874,159.47,171.425c0.039,18.232,5.088,35.409,5.256,53.446c0.16,17.089-22.096,32.404-18.132,67.322 C150.174,323.739,189.868,362.493,210.578,374.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M210.578,374.09c25.991,14.555,62.376,26.908,86.778-0.889 c12.221-13.921,18.111-33.358,31.55-46.557c14.316-14.06,28.631-20.721,39.488-40.646c42.186-77.424-2.704-160.271-59.25-183.071 C262.377,84.07,159.27,78.874,159.47,171.425c0.039,18.232,5.088,35.409,5.256,53.446c0.16,17.089-22.096,32.404-18.132,67.322 C150.174,323.739,189.868,362.493,210.578,374.09z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__150_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M345.092,107.263c-10.807,6.35-2.093,12.921-3.754,19.289c-1.661,6.368-1.487,8.306,1.287,11.998 c2.774,3.692-5.681,5.26,0.531,8.583c6.212,3.322,30.577,0.35,25.87-21.006C364.319,104.771,351.061,103.756,345.092,107.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M342.667,147.133c-0.028,0-0.057-0.004-0.087-0.014c-1.749-0.575-2.748-1.288-3.055-2.179 c-0.401-1.163,0.399-2.361,1.246-3.63c1.039-1.556,2.02-3.025,0.926-4.437c-0.288-0.371-0.56-0.711-0.814-1.028 c-2.245-2.801-3.174-3.961-0.879-9.583c0.849-2.081,0.275-3.957-0.333-5.943c-1.089-3.561-2.324-7.598,5.256-13.278 c0.125-0.09,0.297-0.067,0.388,0.056c0.092,0.122,0.067,0.296-0.055,0.388c-7.27,5.447-6.146,9.12-5.059,12.672 c0.609,1.992,1.239,4.052,0.316,6.315c-2.172,5.32-1.423,6.255,0.799,9.027c0.255,0.319,0.529,0.661,0.819,1.035 c1.34,1.727,0.149,3.51-0.902,5.084c-0.769,1.151-1.495,2.239-1.183,3.142c0.247,0.716,1.131,1.316,2.705,1.833 c0.145,0.048,0.224,0.204,0.176,0.35C342.892,147.059,342.784,147.133,342.667,147.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M350.152,171.024c-1.062,4.932-2.286,9.863-3.521,14.773c-1.258,4.909-2.549,9.809-3.882,14.695 l-0.5,1.832l-0.25,0.916l-0.235,0.829c-0.09,0.318-0.232,0.668-0.359,0.995c-0.537,1.338-1.449,2.715-2.578,3.772 c-1.133,1.068-2.418,1.792-3.592,2.241c-2.381,0.893-4.355,0.956-6.094,0.904c-1.742-0.095-3.286-0.374-4.749-0.719 c-2.911-0.717-5.51-1.72-7.995-2.876c-2.499-1.165-4.796-2.426-7.138-3.985c-1.658-1.104-2.108-3.342-1.004-5 c0.851-1.278,2.377-1.839,3.791-1.522l0.2,0.047c4.66,1.055,9.616,2.171,13.867,2.348c1.047,0.048,2.043,0.015,2.844-0.114 c0.793-0.095,1.394-0.35,1.36-0.458c-0.005-0.047-0.196-0.015-0.433,0.15c-0.229,0.161-0.431,0.448-0.527,0.593 c-0.029,0.025-0.04,0.083-0.061,0.091l-0.022,0.028c0,0-0.009,0.031-0.003-0.006l0.02-0.118l0.162-0.945l0.324-1.892 c0.878-5.039,1.849-10.053,2.89-15.05c1.066-4.995,2.174-9.961,3.492-14.916c1.023-3.843,4.967-6.13,8.81-5.106 c3.725,0.991,5.988,4.727,5.191,8.456L350.152,171.024z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M340.587,156.564c-6.179,3.025-8.281,18.915-8.281,18.915l18.685,10.709 c0,0,7.455-14.075,4.909-23.28C354.461,157.703,351.264,151.337,340.587,156.564z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M313.425,198.143l-5.177-2.987l-0.737,9.027c0,0,4.396,2.964,7.388-0.439l0.417-2.117 C315.34,200.127,314.646,198.848,313.425,198.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M301.881,197.311l-0.649,3.229c-0.173,0.859,0.229,1.609,1.002,1.869l5.278,1.774l0.737-9.027 l-3.888,0.082C303.218,195.262,302.106,196.193,301.881,197.311z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F3E3B"
    },
    points: "376.104,406.536 366.589,406.75 364.821,385.078 374.335,384.863  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M365.958,405.578h10.534c0.383,0,0.694,0.266,0.748,0.64l1.2,8.335 c0.125,0.864-0.619,1.683-1.503,1.667c-3.673-0.063-5.443-0.279-10.075-0.279c-2.85,0-11.036,0.296-14.972,0.296 c-3.849,0-4.145-3.892-2.507-4.244c7.348-1.58,12.531-3.76,15.007-5.839C364.837,405.78,365.397,405.578,365.958,405.578z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "364.823,385.083 365.733,396.255 375.251,396.04 374.341,384.869  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M388.375,155.13c-0.39-4.256-3.933-7.505-8.207-7.564c-11.591-0.159-27.059,3.512-36.345,7.472 c-3.311,1.412-5.55,4.558-5.789,8.15c-0.105,1.574-0.116,3.532,0.036,5.944c0,0-0.002-0.003-0.002-0.003 c-0.557,2.329-4.828,19.658,3.477,22.75c0.214,0.08,0.403,0.127,0.595,0.178c1.862,7.301,4.483,16.064,8.139,26.589 c14.886-2.602,40.295-8.249,47.539-9.515C398.395,198.034,390.915,182.843,388.375,155.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M369.602,129.712c-0.533,5.742-0.265,16.044,5.694,18.771c0,0-5.169,10.432-19.735,17.569 c-8.614-4.984-3.899-13.437-3.899-13.437c8.225-2.942,7.213-7.438,4.992-11.439L369.602,129.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M351.812,152.496c0.18-0.369-0.141-0.794-0.547-0.73c-7.216,1.134-12.414,4.412-13.665,13.178 c-0.716,5.019-2.187,11.786-2.507,18.889c-0.089,1.965,1.385,5.23,3.001,5.984c0.916,7.705,2.551,15.234,5.061,20.673 c5.103,2.2,9.979-0.194,9.979-0.194S344.246,168.042,351.812,152.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M373.476,147.272c-8.565,3.181-9.065,7.608-8.153,19.795c1.036,13.844,5.456,32.025,7.806,39.716 c17.535-3.681,25.256-10.521,25.256-10.521s-5.94-36.703-7.979-42.884C388.367,147.196,379.936,144.872,373.476,147.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M364.324,134.388l-7.664,6.782c0.531,0.946,0.985,1.92,1.257,2.896 c3.297,0.534,7.249-3.071,7.401-5.572C365.393,137.246,364.699,134.908,364.324,134.388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M369.674,118.731c0.674,9.282,1.157,13.196-2.856,18.547c-6.037,8.049-17.584,6.847-21.018-2.047 c-3.09-8.005-3.673-21.838,4.844-26.715C359.036,103.712,369,109.45,369.674,118.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M350.28,218.647c0,0-5.649,55.475-3.13,83.965c2.619,29.634,15.304,91.368,15.304,91.368h15.447 c0,0,0.711-69.36-3.734-100.454c5.647-31.819,10.812-80.927,7.932-80.441L350.28,218.647z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "379,394.435 361.355,394.435 360.264,389.69 379.691,389.109  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M374.326,234.569c2.508-4.603,5.342-4.822,7.632-2.496c-1.26,15.979-3.913,38.101-6.857,55.97 C370.619,272.318,365.797,250.233,374.326,234.569z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F3E3B"
    },
    points: "448.44,374.872 439.428,379.227 426.669,361.276 435.681,356.921  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M437.869,378.171l7.404-7.493c0.269-0.273,0.702-0.331,1.04-0.141l7.533,4.235 c0.781,0.439,0.915,1.468,0.282,2.087c-2.632,2.574-4.049,3.701-7.305,6.997c-2.003,2.027-7.938,8.44-11.434,10.249 c-3.419,1.769-5.919-1.32-4.666-2.365c5.618-4.686,6.436-9.07,6.507-12.101C437.243,379.091,437.475,378.57,437.869,378.171z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "426.675,361.28 433.25,370.534 442.266,366.177 435.69,356.923  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M365.005,216.073c0,0,7.262,57.164,20.012,83.122c13.262,27,44.772,69.226,44.772,69.226 l11.876-4.442c0,0-16.464-48.037-33.458-76.887c-1.642-31-1.985-64.515-10.151-76.796L365.005,216.073z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "442.851,363.356 430.167,370.196 426.13,366.336 441.435,357.452  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M436.71,381.676c-0.656,0.664-1.376,1.187-2.062,1.265c-0.436,0.05-0.822-0.077-1.15-0.375 c-0.195-0.179-0.268-0.396-0.209-0.629c0.302-1.201,4.462-2.695,4.934-2.861c0.094-0.033,0.2-0.011,0.266,0.056 c0.065,0.067,0.076,0.162,0.025,0.24C438.082,380.035,437.436,380.941,436.71,381.676z M433.978,381.68 c-0.121,0.122-0.2,0.238-0.227,0.344c-0.024,0.096,0.003,0.173,0.09,0.252c0.221,0.203,0.467,0.285,0.75,0.253 c0.81-0.092,1.966-1.135,3.15-2.824C436.342,380.242,434.603,381.048,433.978,381.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M438.488,379.405c-0.022,0.022-0.049,0.04-0.08,0.053c-1.191,0.487-4.368,0.825-5.099,0.053 c-0.173-0.183-0.299-0.501,0.083-0.976c0.282-0.351,0.677-0.568,1.172-0.641c1.616-0.239,3.794,1.148,3.886,1.207 c0.067,0.043,0.103,0.115,0.094,0.188C438.54,379.333,438.52,379.373,438.488,379.405z M433.867,378.674 c-0.031,0.031-0.06,0.064-0.088,0.099c-0.252,0.314-0.14,0.431-0.104,0.47c0.439,0.463,2.77,0.367,4.125-0.022 c-0.667-0.371-2.101-1.073-3.162-0.916C434.319,378.352,434.065,378.473,433.867,378.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M354.452,123.424c0.101,0.75-0.215,1.411-0.704,1.477c-0.49,0.066-0.969-0.488-1.07-1.238 c-0.101-0.75,0.215-1.411,0.704-1.477C353.872,122.12,354.351,122.674,354.452,123.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M345.979,124.564c0.101,0.75-0.214,1.411-0.704,1.477c-0.49,0.066-0.969-0.488-1.07-1.238 c-0.101-0.75,0.215-1.411,0.704-1.477C345.4,123.26,345.879,123.815,345.979,124.564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M345.132,123.339l-1.87-0.277C343.262,123.062,344.375,124.344,345.132,123.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#630F0F"
    },
    d: "M349.644,125.291c0,0-0.838,3.398-2.028,5.144c1.114,0.79,2.74,0.142,2.74,0.142L349.644,125.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M354.839,132.961c-0.338,0.1-0.702,0.179-1.093,0.232c-0.122,0.016-0.234-0.069-0.25-0.19 c-0.017-0.122,0.079-0.235,0.19-0.25c3.3-0.445,4.517-2.948,4.529-2.973c0.053-0.111,0.184-0.158,0.296-0.105 c0.111,0.053,0.158,0.185,0.105,0.296C358.568,130.07,357.543,132.164,354.839,132.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M373.285,126.3c-0.646,2.156-2.177,3.741-3.753,4.501c-2.371,1.143-4.057-1.089-3.817-3.754 c0.216-2.399,1.711-5.884,4.292-5.902C372.551,121.128,374.024,123.835,373.285,126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M343.156,108.739c1.359,4.002,10.978,2.734,11.962,6.829c0.984,4.095,0.666,9.014,5.874,9.154 s6.897,7.643,6.173,11.334c-0.723,3.692,0.795,10.887,10.116,8.521c9.321-2.366,12.962-10.893,6.891-18.95 c-3.431-4.553-1.958-5.046-1.761-10.029c0.161-4.067,0.049-9.66-5.93-11.259c-5.499-1.472-7.119,0.692-12.49-3.199 C355.489,94.981,339.698,98.561,343.156,108.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M357.219,120.664c-0.183,0.038-0.378-0.043-0.476-0.215c-1.02-1.784-3.652-2.054-3.678-2.057 c-0.244-0.023-0.423-0.24-0.4-0.484c0.023-0.244,0.238-0.424,0.484-0.4c0.127,0.012,3.119,0.321,4.365,2.5 c0.122,0.213,0.048,0.484-0.165,0.606C357.307,120.638,357.263,120.655,357.219,120.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M343.267,121.21c-0.136,0.067-0.302,0.063-0.439-0.025c-0.206-0.133-0.265-0.408-0.132-0.614 c1.333-2.063,3.385-2.095,3.471-2.095c0.246-0.001,0.445,0.197,0.446,0.442c0.001,0.244-0.196,0.444-0.441,0.446l0,0 c-0.068,0.001-1.665,0.042-2.73,1.689C343.397,121.123,343.336,121.175,343.267,121.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M391.056,153.998c1.458,0.713,2.662,1.342,3.941,2.064c1.265,0.695,2.495,1.44,3.722,2.192 c2.443,1.523,4.847,3.12,7.177,4.865c4.656,3.497,9.151,7.389,13.068,12.368l0.384,0.478c0.265,0.344,0.526,0.709,0.715,1.029 c0.415,0.671,0.688,1.266,0.921,1.833c0.446,1.121,0.705,2.093,0.885,3.012c0.353,1.825,0.465,3.43,0.527,4.993 c0.117,3.103-0.126,5.998-0.402,8.852c-0.655,5.703-1.683,11.146-3.228,16.62c-0.54,1.914-2.529,3.027-4.443,2.486 c-1.548-0.437-2.571-1.821-2.621-3.347l-0.002-0.105c-0.166-5.329-0.237-10.751-0.581-15.937c-0.142-2.588-0.415-5.15-0.778-7.473 c-0.192-1.146-0.438-2.25-0.731-3.071c-0.146-0.402-0.288-0.737-0.385-0.865c-0.043-0.055-0.074-0.072-0.035,0.03 c0.013,0.028,0.061,0.127,0.12,0.201l-0.291-0.289c-1.561-1.654-3.431-3.218-5.316-4.767c-1.931-1.523-3.984-2.983-6.073-4.412 c-2.113-1.406-4.275-2.783-6.476-4.104c-1.095-0.67-2.212-1.309-3.317-1.954l-3.239-1.831l-0.245-0.139 c-3.46-1.955-4.679-6.346-2.723-9.806C383.512,153.594,387.664,152.349,391.056,153.998z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M381.326,147.663c8.157-0.624,19.248,10.059,19.248,10.059l-7.482,16.158 c0,0-12.025-2.325-16.653-8.259C371.497,159.284,375.289,148.125,381.326,147.663z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M362.438,407.217c-0.933,0-1.792-0.144-2.274-0.577c-0.306-0.275-0.441-0.639-0.401-1.082 c0.024-0.264,0.154-0.469,0.377-0.59c1.148-0.629,4.887,1.279,5.309,1.499c0.084,0.043,0.131,0.135,0.117,0.228 c-0.013,0.093-0.084,0.168-0.177,0.186C364.592,407.04,363.471,407.217,362.438,407.217z M360.767,405.277 c-0.172,0-0.313,0.025-0.414,0.081c-0.092,0.05-0.137,0.124-0.147,0.241c-0.027,0.3,0.056,0.532,0.255,0.711 c0.569,0.511,2.112,0.601,4.19,0.256C363.364,405.948,361.655,405.277,360.767,405.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M365.346,406.886c-0.031,0-0.062-0.007-0.091-0.02c-1.118-0.505-3.329-2.527-3.156-3.589 c0.041-0.252,0.219-0.565,0.834-0.627c0.454-0.046,0.869,0.083,1.23,0.383c1.179,0.982,1.395,3.506,1.404,3.613 c0.006,0.078-0.029,0.154-0.093,0.199C365.436,406.872,365.391,406.886,365.346,406.886z M363.112,403.085 c-0.044,0-0.088,0.002-0.134,0.007c-0.405,0.041-0.432,0.203-0.441,0.257c-0.104,0.638,1.397,2.228,2.536,2.919 c-0.11-0.735-0.422-2.249-1.195-2.893C363.645,403.18,363.393,403.085,363.112,403.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M353.604,122.198l-1.87-0.276C351.734,121.922,352.847,123.203,353.604,122.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M397.899,208.055l1.546,3.19c0.177,0.238-0.085,0.557-0.519,0.633l-48.537,8.484 c-0.338,0.059-0.647-0.058-0.706-0.267l-0.925-3.299c-0.064-0.229,0.195-0.477,0.565-0.541l47.916-8.376 C397.518,207.831,397.785,207.902,397.899,208.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M387.959,214.17l1.017-0.178c0.203-0.035,0.339-0.167,0.303-0.292l-1.24-4.279 c-0.036-0.125-0.232-0.199-0.434-0.163l-1.017,0.178c-0.203,0.035-0.339,0.167-0.302,0.292l1.24,4.279 C387.561,214.132,387.756,214.205,387.959,214.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M353.312,220.226l1.017-0.178c0.203-0.035,0.339-0.167,0.302-0.292l-1.24-4.279 c-0.036-0.125-0.232-0.199-0.434-0.163l-1.017,0.178c-0.203,0.035-0.339,0.167-0.302,0.292l1.24,4.279 C352.914,220.188,353.109,220.262,353.312,220.226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M363.717,218.456l7.837-1.37c0.221-0.039,0.369-0.182,0.329-0.318l-1.35-4.661 c-0.04-0.136-0.252-0.216-0.473-0.178l-7.836,1.37c-0.221,0.039-0.369,0.182-0.329,0.318l1.35,4.661 C363.284,218.415,363.497,218.495,363.717,218.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M411.698,209.577l-1.823,7.385l8.889-0.133c0,0,2.647-5.301-0.459-7.656L411.698,209.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M413.713,222.85l1.576-0.072c1.735-0.079,3.137-1.441,3.267-3.172l0.208-2.778l-8.889,0.133 l0.265,2.785C410.314,221.568,411.885,222.933,413.713,222.85z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M186.761,196.337l14.364,17.163c2.611,3.12,6.565,4.793,10.623,4.494l63.794-4.697 c9.911-0.73,18.537,6.713,19.267,16.624l8.676,117.826c0.73,9.911-6.713,18.537-16.624,19.267l-176.874,13.024 c-9.911,0.73-18.537-6.713-19.267-16.624L79.544,211.632c-0.513-6.963,4.716-13.023,11.679-13.536l84.914-6.253 C180.196,191.544,184.149,193.217,186.761,196.337z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.761,196.337l14.364,17.163c2.611,3.12,6.565,4.793,10.623,4.494l63.794-4.697 c9.911-0.73,18.537,6.713,19.267,16.624l8.676,117.826c0.73,9.911-6.713,18.537-16.624,19.267l-176.874,13.024 c-9.911,0.73-18.537-6.713-19.267-16.624L79.544,211.632c-0.513-6.963,4.716-13.023,11.679-13.536l84.914-6.253 C180.196,191.544,184.149,193.217,186.761,196.337z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M155.077,207.132l-60.555,4.459c-1.363,0.1-2.561-0.933-2.661-2.296l-0.005-0.072 c-0.1-1.363,0.933-2.561,2.296-2.661l60.555-4.459c1.363-0.1,2.561,0.933,2.661,2.296l0.005,0.072 C157.473,205.834,156.44,207.031,155.077,207.132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M146.72,217.876l-51.456,3.789c-1.363,0.1-2.561-0.933-2.661-2.296l-0.005-0.072 c-0.1-1.363,0.933-2.561,2.296-2.661l51.456-3.789c1.363-0.1,2.561,0.933,2.661,2.296l0.005,0.072 C149.116,216.579,148.083,217.776,146.72,217.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M292.67,360.312l-185.806,13.681c-4.659,0.343-8.751-3.188-9.094-7.847l-8.435-114.554 c-0.343-4.659,3.188-8.751,7.847-9.094l185.806-13.681c4.659-0.343,8.751,3.188,9.094,7.847l8.435,114.554 C300.86,355.876,297.329,359.969,292.67,360.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M292.67,360.312l-183.143,13.485c-4.659,0.343-8.751-3.188-9.094-7.847l-8.435-114.553 c-0.343-4.659,3.188-8.751,7.847-9.094l183.143-13.485c4.659-0.343,8.751,3.188,9.094,7.847l8.435,114.554 C300.86,355.876,297.329,359.969,292.67,360.312z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "115.521,373.356 153.861,370.533 119.152,256.374  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.81,328.328l-183.723,30.931c-4.607,0.776-9.01-2.359-9.786-6.966l-19.07-113.27 c-0.776-4.607,2.359-9.01,6.966-9.786l183.723-30.931c4.607-0.776,9.01,2.359,9.786,6.966l19.07,113.27 C336.551,323.149,333.417,327.552,328.81,328.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#407BFF"
    },
    d: "M328.81,328.328l-181.09,30.487c-4.607,0.776-9.01-2.359-9.786-6.966l-19.07-113.27 c-0.776-4.607,2.359-9.01,6.966-9.786l181.09-30.488c4.607-0.776,9.01,2.359,9.786,6.966l19.07,113.27 C336.551,323.149,333.417,327.552,328.81,328.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#407BFF"
    },
    d: "M304.616,222.685L135.99,251.074c-2.032,0.342-3.974-1.04-4.316-3.072l-0.948-5.631 c-0.342-2.032,1.04-3.974,3.072-4.316l168.626-28.389c2.032-0.342,3.974,1.04,4.316,3.072l0.948,5.631 C308.03,220.401,306.647,222.343,304.616,222.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#407BFF"
    },
    d: "M306.443,232.82l-168.861,28.429c-1.967,0.331-3.305,2.211-2.974,4.178l0.835,4.961 c0.331,1.967,2.211,3.305,4.178,2.974l168.861-28.429c1.967-0.331,3.305-2.211,2.974-4.178l-0.835-4.962 C310.29,233.827,308.41,232.489,306.443,232.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M329.065,366.508l-0.355-0.935c2.313-0.879,4.432-2.158,6.301-3.8l0.66,0.751 C333.712,364.246,331.489,365.586,329.065,366.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M340.774,355.921l-0.893-0.449c1.675-3.333,2.415-7.067,2.141-10.799l-1.103-14.963l0.998-0.073 l1.103,14.963C343.308,348.512,342.531,352.427,340.774,355.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M322.691,364.372l-194.524,14.323l0,0.003l-18.18,1.339c10.041-0.739,17.581-9.478,16.841-19.519 l-5.873-79.761c-0.488-6.631,4.492-12.403,11.123-12.891l188.687-13.894c6.631-0.488,12.403,4.492,12.891,11.123l5.873,79.762 C340.268,354.895,332.729,363.633,322.691,364.372z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg97127264170014);
export default __webpack_public_path__ + "static/media/9712726_4170014.755401a5d82f240dc755c9fbed9e051e.svg";
export { ForwardRef as ReactComponent };